module.exports = __webpack_public_path__ + "img/mastercard.acf1c8ee.png";